/*
  Hotfix: wrap PhotoSwipe.prototype.close to catch errors coming from getThumbBoundsFn
  Safe wrapper for PhotoSwipe.close
*/
(function(){
  if (!window.PhotoSwipe) {
    var attempts = 0;
    var max = 50;
    var t = setInterval(function(){
      attempts++;
      if (window.PhotoSwipe) {
        clearInterval(t);
        installWrap();
      } else if (attempts > max) {
        clearInterval(t);
      }
    }, 200);
  } else {
    installWrap();
  }

  function installWrap(){
    try {
      if (!window.PhotoSwipe || !window.PhotoSwipe.prototype) return;
      if (window.__pswp_close_wrapped) return;
      window.__pswp_close_wrapped = true;
      var origClose = window.PhotoSwipe.prototype.close;
      window.PhotoSwipe.prototype.close = function() {
        try {
          return origClose.apply(this, arguments);
        } catch (err) {
        
          try { if (typeof this.destroy === 'function') this.destroy(); } catch (e) {}
          return;
        }
      };
    
    } catch (e) {
    
    }
  }
})();
